import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.resize(); // Ajuste la taille dès l'initialisation
  }

  resize() {
    this.inputTarget.style.width = "auto"; // Réinitialise la largeur pour éviter un bug visuel

    let textLength = (this.inputTarget.value.length || 1) + 2;
    this.inputTarget.style.width = `${textLength}ch`; // Ajuste la largeur en fonction du texte
  }
}